var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.5H4V4.5625C4 2.90625 5.3125 1.53125 6.96875 1.5C8.625 1.5 10 2.84375 10 4.5V5.25C10 5.6875 10.3125 6 10.75 6C11.1562 6 11.5 5.6875 11.5 5.25V4.5625C11.5 2.0625 9.5 0.03125 7 0C4.5 0 2.5 2.03125 2.5 4.5V7.5H1.5C0.65625 7.5 0 8.1875 0 9V14.5C0 15.3438 0.65625 16 1.5 16H12.5C13.3125 16 14 15.3438 14 14.5V9C14 8.1875 13.3125 7.5 12.5 7.5ZM12.5 14.5H1.5V9H12.5V14.5ZM7 13.5C7.46875 13.5 7.875 13.125 7.875 12.625V10.875C7.875 10.4062 7.46875 10 7 10C6.5 10 6.125 10.4062 6.125 10.875V12.625C6.125 13.125 6.5 13.5 7 13.5Z",
    fill: "#1976D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivate);
export default __webpack_public_path__ + "static/media/private.7ed131827792cdfbcf0d1bf96c17cea1.svg";
export { ForwardRef as ReactComponent };